import React, { useContext } from "react";
import { IoMdAlert } from "react-icons/io";
import { IoClose } from "react-icons/io5";
import { MessageContext } from "../../contexts/MessageContext";
import "../../assets/css/component-alert-error.css";

export default function AlertError({ msg }) {
  const { setVisibleMessageErrorForUser } = useContext(MessageContext);
  return (
    <>
      <div className="error">
        <div className="error__icon">
          <IoMdAlert />
        </div>
        <div className="error__title">{msg}</div>
        <div
          className="error__close"
          onClick={() => setVisibleMessageErrorForUser(null)}
        >
          <IoClose />
        </div>
      </div>
    </>
  );
}
